export default {
  state: {
    adtabs: ""
  }
};



// WEBPACK FOOTER //
// ./src/store/module/spmanage.js